import convertTimesArrayToString from './convertTimesArrayToString';
import { CardLoadPerfCheckpoints } from 'owa-actionable-message';
import { differenceInMilliseconds } from 'owa-datetime';

export default function generateGenericInfoFromPerfCheckpoints(
    perfCheckpoints: CardLoadPerfCheckpoints
): string {
    // Calculate the total time spent getting the final card ready to render.
    // This measures the total time from when the item is first loaded in the reading pane until
    // the final card is rendered (after any auto-exec actions are run)
    const totalCardRenderingTime = differenceInMilliseconds(
        perfCheckpoints.currentCardCheckpoints.cardRenderEnd,
        perfCheckpoints.loadStart
    );

    // Calculate time spend processing the card for both the final card and (if present the initial card).
    const finalCardProcessingTime = differenceInMilliseconds(
        perfCheckpoints.currentCardCheckpoints.cardCreateEnd,
        perfCheckpoints.currentCardCheckpoints.cardCreateStart
    );
    const initialCardProcessingTime = perfCheckpoints.initialCardCheckpoints
        ? differenceInMilliseconds(
              perfCheckpoints.initialCardCheckpoints.cardCreateEnd,
              perfCheckpoints.initialCardCheckpoints.cardCreateStart
          )
        : 0;

    // Calculate the total time spent rendering the card (both final and if present, the initial card)
    const finalCardRenderingTime = differenceInMilliseconds(
        perfCheckpoints.currentCardCheckpoints.cardRenderEnd,
        perfCheckpoints.currentCardCheckpoints.cardRenderStart
    );
    const initialCardRenderingTime = perfCheckpoints.initialCardCheckpoints
        ? differenceInMilliseconds(
              perfCheckpoints.initialCardCheckpoints.cardRenderEnd,
              perfCheckpoints.initialCardCheckpoints.cardRenderStart
          )
        : 0;

    // Calculate the time spent waiting for auto-invoke actions to complete
    const autoInvokeTime = differenceInMilliseconds(
        perfCheckpoints.autoInvokeActionEnd,
        perfCheckpoints.autoInvokeActionStart
    );

    // Calculate the time spent waiting for the theme to load
    const finalCardThemeLoadTime = differenceInMilliseconds(
        perfCheckpoints.currentCardCheckpoints.themeLoadTotalEnd,
        perfCheckpoints.currentCardCheckpoints.themeLoadTotalStart
    );
    const initialCardThemeLoadTime = perfCheckpoints.initialCardCheckpoints
        ? differenceInMilliseconds(
              perfCheckpoints.initialCardCheckpoints.themeLoadTotalEnd,
              perfCheckpoints.initialCardCheckpoints.themeLoadTotalStart
          )
        : 0;

    // Calculate the time spent fetching the cards (i.e. time spent waiting for getItem to get the cards)
    const finalCardTimeSpendFetching = perfCheckpoints.currentCardCheckpoints.totalFetchTime;
    const initialCardTimeSpendFetching = perfCheckpoints.initialCardCheckpoints
        ? perfCheckpoints.initialCardCheckpoints.totalFetchTime
        : 0;

    // Calculate the total time spent in the adaptive card js library's render function (both final and if present, the initial card)
    const finalCardHtmlRenderingTime = differenceInMilliseconds(
        perfCheckpoints.currentCardCheckpoints.cardLibraryRenderEnd,
        perfCheckpoints.currentCardCheckpoints.cardLibraryRenderStart
    );
    const initialCardHtmlRenderingTime = perfCheckpoints.initialCardCheckpoints
        ? differenceInMilliseconds(
              perfCheckpoints.initialCardCheckpoints.cardLibraryRenderEnd,
              perfCheckpoints.initialCardCheckpoints.cardLibraryRenderStart
          )
        : 0;

    // Calculatte the total time spent in the post-render preparation (i.e. fixing image references, adjusting spacing, etc.)
    const finalCardPrepareCardTime = differenceInMilliseconds(
        perfCheckpoints.currentCardCheckpoints.prepareCardEnd,
        perfCheckpoints.currentCardCheckpoints.prepareCardStart
    );
    const initialCardPrepareCardTime = perfCheckpoints.initialCardCheckpoints
        ? differenceInMilliseconds(
              perfCheckpoints.initialCardCheckpoints.prepareCardEnd,
              perfCheckpoints.initialCardCheckpoints.prepareCardStart
          )
        : 0;

    const renderingTimes = [];
    renderingTimes['TCRT'] = totalCardRenderingTime;
    renderingTimes['FCRT'] = finalCardRenderingTime;
    renderingTimes['ICRT'] = initialCardRenderingTime;
    renderingTimes['FCPT'] = finalCardProcessingTime;
    renderingTimes['AIT'] = autoInvokeTime;
    renderingTimes['ICRT'] = initialCardProcessingTime;
    renderingTimes['FCTT'] = finalCardThemeLoadTime;
    renderingTimes['ICTT'] = initialCardThemeLoadTime;
    renderingTimes['FCFT'] = finalCardTimeSpendFetching;
    renderingTimes['ICFT'] = initialCardTimeSpendFetching;
    renderingTimes['FCHT'] = finalCardHtmlRenderingTime;
    renderingTimes['ICHT'] = initialCardHtmlRenderingTime;
    renderingTimes['FCPT'] = finalCardPrepareCardTime;
    renderingTimes['ICPT'] = initialCardPrepareCardTime;

    return convertTimesArrayToString(renderingTimes);
}
